import React from "react";
import "./ErrorBoundary.css";

/**
 * Catches unexpected JS errors anywhere in the component tree.
 * Shows a branded fallback UI instead of a blank / crashed page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMsg: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMsg: error?.message || "Unknown error" };
  }

  componentDidCatch(error, info) {
    // Development: log to console for easy debugging
    if (process.env.NODE_ENV === "development") {
      console.error("[ErrorBoundary]", error, info.componentStack);
    }
    // Production: send to Sentry (or your error monitoring service).
    // Uncomment after running: npm install @sentry/react
    //
    // import * as Sentry from "@sentry/react";
    // Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
  }

  handleRetry = () => {
    this.setState({ hasError: false, errorMsg: "" });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="eb-wrap">
        <div className="eb-card">
          <div className="eb-icon">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>
          <h1 className="eb-heading">SOMETHING WENT WRONG</h1>
          <p className="eb-sub">An unexpected error occurred. We're sorry for the inconvenience.</p>
          {process.env.NODE_ENV === "development" && (
            <p className="eb-detail">{this.state.errorMsg}</p>
          )}
          <div className="eb-actions">
            <button className="eb-btn-primary" onClick={this.handleRetry}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                <polyline points="1 4 1 10 7 10"/>
                <path d="M3.51 15a9 9 0 1 0 .49-3.83"/>
              </svg>
              TRY AGAIN
            </button>
            <a className="eb-btn-secondary" href="/">GO TO HOME</a>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
